module.exports = {
      id: "icon-menu-close-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-menu-close",
      toString: function () {
        return this.url;
      }
    }